/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Form_HintInputs */

const en_us2_engagement_form_hint = /** @type {(inputs: Engagement_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your message goes straight to the team.`)
};

const pt_br2_engagement_form_hint = /** @type {(inputs: Engagement_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua mensagem vai direto para a equipe.`)
};

const es_419_engagement_form_hint = /** @type {(inputs: Engagement_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu mensaje llega directo al equipo.`)
};

const pt_pt2_engagement_form_hint = /** @type {(inputs: Engagement_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua mensagem vai diretamente para a equipa.`)
};

const fr_fr2_engagement_form_hint = /** @type {(inputs: Engagement_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton message va directement à l'équipe.`)
};

const de_de2_engagement_form_hint = /** @type {(inputs: Engagement_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Nachricht geht direkt ans Team.`)
};

const it_it2_engagement_form_hint = /** @type {(inputs: Engagement_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo messaggio arriva direttamente al team.`)
};

/**
* | output |
* | --- |
* | "Your message goes straight to the team." |
*
* @param {Engagement_Form_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_form_hint = /** @type {((inputs?: Engagement_Form_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Form_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_form_hint(inputs)
	if (locale === "es-419") return es_419_engagement_form_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_form_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_form_hint(inputs)
	if (locale === "de-DE") return de_de2_engagement_form_hint(inputs)
	if (locale === "it-IT") return it_it2_engagement_form_hint(inputs)
	return en_us2_engagement_form_hint(inputs)
});
export { engagement_form_hint as "engagement.form_hint" }